import React, { useEffect, useState, Fragment } from "react";
import cardsBg from "assets/images/common/others/cardsBg.png"
import { useNavigate } from "react-router-dom";
import useUsers from "containers/user-management/useHooks";
import { useSelector } from "react-redux";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import DataNotFound from "components/particles/table/data-not-found";
import Pagination from "components/particles/table/pagination";
import { UserFiltersDTO } from "utils/helpers/models/common/user-filters.dto";
import { siteRoutes } from "utils/helpers/enums/routes.enum";



interface Props {
  attendeeId: number;
}
const FavoriteHost = ({ attendeeId }: Props) => {
  const navigate = useNavigate();
  const { getFavoriteHostById } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [data, setData] = useState<any[]>([]);
  const [filters, setFilters] = useState<UserFiltersDTO>(new UserFiltersDTO());
  const [totalElements, setTotalElements] = useState<number>(0);

  const fetchFavoriteHosts = (filterParams?: UserFiltersDTO) => {
    const activeFilters = filterParams || filters;
    const queryparam = {
      attendeeId: attendeeId,
      page: activeFilters.page - 1,
      size: activeFilters.size || 10,
    };

    getFavoriteHostById(queryparam, setData, setFilters, setTotalElements);
  };

  useEffect(() => {
    fetchFavoriteHosts();
  }, [attendeeId]);

  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page, limit } = pageInfo;
    const updatedFilters = { ...filters, page: page + 1, size: limit };
    setFilters(updatedFilters);
    fetchFavoriteHosts(updatedFilters);
  };

  const goToHostDetail = (id: number) => {
    navigate(`${siteRoutes.viewHost}?id=${id}`);
  };

  console.log(data);
  return (
    <div>
      <div className="flex flex-wrap items-center gap-4 py-5">
        {data.map((item: any, index: number) => (
          <div
            key={index}
            onClick={() => goToHostDetail(item?.id)}
            className="flex flex-col items-center justify-center p-4 border border-lightBorder min-w-[220px] min-h-[230px] cursor-pointer bg-cover bg-center bg-no-repeat rounded-3xl"
            style={{ backgroundImage: `url(${cardsBg})` }}
          >
            <div className="hover:scale-110 transition-transform duration-300">
              <img
                className="w-[100px] h-[100px] object-cover rounded-full"
                src={
                  item?.profilePicUrl
                    ? concatPathWithBackendUrl(
                      item?.profilePicUrl?.fileDownloadUri
                    )
                    : editProfilePicUser
                }
                alt={item?.firstName}
              />
            </div>
            <span className="text-base font-semibold my-2 text-primaryText">
              {item?.firstName} {item?.lastName}
            </span>
            {/* <div className="flex justify-center gap-2">
              <span className="">
                <ReviewIcon />
              </span>
              <span className="text-sm  text-primaryText">(5.0)</span>
            </div> */}
          </div>
        ))}
      </div>
      <Fragment>
        <div className="mt-10 text-9xl">
          <DataNotFound show={!isLoading && !data.length} />
        </div>
        {totalElements > 9 && (
          <Pagination
            count={totalElements}
            page={filters.page}
            limit={filters.size}
            onPageChange={onPageChange}
          />
        )}
      </Fragment>
    </div>
  );
};

export default FavoriteHost;
